import LendingPage from 'screens/Lending/Lending';

export default LendingPage;
